var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextarea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 8.66699H4C3.45333 8.66699 3 8.21366 3 7.66699C3 7.12033 3.45333 6.66699 4 6.66699H28C28.5467 6.66699 29 7.12033 29 7.66699C29 8.21366 28.5467 8.66699 28 8.66699Z",
    fill: "#3D48E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14.667H4C3.45333 14.667 3 14.2137 3 13.667C3 13.1203 3.45333 12.667 4 12.667H28C28.5467 12.667 29 13.1203 29 13.667C29 14.2137 28.5467 14.667 28 14.667Z",
    fill: "#3D48E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 20.667H4C3.45333 20.667 3 20.2137 3 19.667C3 19.1203 3.45333 18.667 4 18.667H28C28.5467 18.667 29 19.1203 29 19.667C29 20.2137 28.5467 20.667 28 20.667Z",
    fill: "#3D48E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 26.667H4C3.45333 26.667 3 26.2137 3 25.667C3 25.1203 3.45333 24.667 4 24.667H28C28.5467 24.667 29 25.1203 29 25.667C29 26.2137 28.5467 26.667 28 26.667Z",
    fill: "#3D48E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextarea);
export default __webpack_public_path__ + "static/media/textarea.33bc84f50df928e5ed7c77e0b843ca27.svg";
export { ForwardRef as ReactComponent };